import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowLeft, ArrowRight, Lock, BookOpen, Calendar, Eye } from 'lucide-react';
import { useLang, pickLocalized, tx } from '../../i18n/LanguageContext';
import { isVideoUrl, colorFor, posterFor } from './articleUtils';

export const ArticleCard = ({ post, categories, getLabel, locked, index }) => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  const cat = post.categories[0];
  return (
    <div className="art-reveal flex" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}>
      <Link to={`/library/post/${post.id}`} data-testid={`article-card-${post.id}`} style={{ '--glow': '#2563eb' }}
        className="plan-glow group w-full flex flex-col bg-white rounded-2xl border border-slate-200/80 p-2.5 shadow-[0_6px_24px_-12px_rgba(15,23,42,0.15)] outline-none">
        <div className="relative aspect-video overflow-hidden rounded-xl bg-slate-100">
          {isVideoUrl(post.cover) && !posterFor(post.cover)
            ? <video src={post.cover} muted playsInline preload="metadata" className="w-full h-full object-cover" />
            : <img src={posterFor(post.cover) || post.cover} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
          <span className={`absolute top-2.5 start-2.5 px-3 py-1 rounded-lg text-xs font-bold shadow-sm ${colorFor(categories, cat).pill}`}>{getLabel(cat, lang)}</span>
          <div className="absolute top-2.5 end-2.5 flex items-center gap-1.5">
            <span data-testid={`article-readtime-${post.id}`} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-slate-900/75 backdrop-blur text-white text-xs font-bold">
              <Clock className="w-3.5 h-3.5" />{post.readMinutes} {L('د', 'min')}
            </span>
            {locked && <span className="w-7 h-7 rounded-full bg-amber-400 flex items-center justify-center shadow"><Lock className="w-3.5 h-3.5 text-slate-900" /></span>}
          </div>
        </div>
        <div className="flex-1 flex flex-col px-2.5 pt-4 pb-1">
          <span data-testid={`article-type-${post.id}`} className="self-start inline-flex items-center gap-1.5 text-emerald-700 text-xs font-bold mb-2"><BookOpen className="w-3.5 h-3.5" />{L('مقال تقني', 'Tech article')}</span>
          <h3 className="text-slate-900 font-black text-base sm:text-lg leading-snug mb-2 line-clamp-2 group-hover:text-blue-700 transition-colors">{pickLocalized(post.title, lang)}</h3>
          <p className="text-slate-500 text-sm leading-relaxed line-clamp-2 mb-4 flex-1">{pickLocalized(post.excerpt, lang)}</p>
          <div className="flex items-center justify-between text-xs text-slate-500 mb-3">
            <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /><span dir="ltr">{post.date}</span></span>
            {post.views > 0 && <span className="flex items-center gap-1.5"><Eye className="w-3.5 h-3.5" />{post.views.toLocaleString('en-US')}</span>}
          </div>
          <span className="h-10 rounded-xl bg-blue-50 group-hover:bg-blue-600 text-blue-700 group-hover:text-white font-bold text-sm inline-flex items-center justify-center gap-2 transition-colors">
            {L('اقرأ المقال', 'Read article')}<Arrow className="w-4 h-4" />
          </span>
        </div>
      </Link>
    </div>
  );
};
